var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-divider',{staticClass:"mb-6 mb-sm-8"})
}
var staticRenderFns = []

export { render, staticRenderFns }